// extracted by mini-css-extract-plugin
export var deleteIcon = "_tc-5";
export var deleteOption = "_tc-3";
export var divider = "_tc-2";
export var downloadIcon = "_tc-4";
export var drawer = "_tc-0";
export var drawerFooter = "_tc-6";
export var drawerOpen = "_tc-1";
export var highlighted = "_tc-7";
export var lighterHighlight = "_tc-8";